import { useState } from 'react'

export default () => {
    const [accessAuth, setAccessAuth] = useState({
        findSupplier: false,
        findGoods: false,
        newlywedZone: true,
    })

    return {
        accessAuth,
        setAccessAuth
    }
}